module.exports = __webpack_public_path__ + "img/close.1480435e.svg";